// import { AuthService } from '../auth-service/auth.service';
import { EXTERNAL_NAME } from '@meltwater/gaf-identity-client/build/external-name.js';
const identityClient: any = window[EXTERNAL_NAME];

class IdentityClientServiceController {
  constructor() {
    this.configureErrorHandler();
  }

  init(): void {
    if (!identityClient) {
      throw new Error('Could not find Identity Client');
    }

    let currentIdentityEnvironment;
    const currentHostName = window.location.hostname;

    if (currentHostName.indexOf('.com') !== -1) {
      currentIdentityEnvironment = identityClient.Environments.PRODUCTION;
    } else {
      currentIdentityEnvironment = identityClient.Environments.STAGING;
    }

    identityClient.Initializer.initialize(currentIdentityEnvironment);
    identityClient.UserClient.getInstance().then((instance) => {
      instance.getCurrentUser();
    });
  }

  configureErrorHandler(): void {
    // identityClient.AuthenticationClient.onError((errorCode) => {
    //   if (errorCode === identityClient.AuthenticationErrorCodes.NOT_SIGNED_IN || errorCode === identityClient.AuthenticationErrorCodes.MISSING_OR_MALFORMED_COOKIE) {
    //     AuthService.logout();
    //   } else {
    //     // just log it?
    //   }
    // });
  }

  async getCurrentCompanyId() {
    const authClient = await identityClient.AuthenticationClient.getInstance();
    const companyId = await authClient.getCurrentCompanyId();
    return companyId;
  }
}

export const IdentityClientService = new IdentityClientServiceController();
